import useWorkOrderSidebarData from './useWorkOrderSidebarData';
import WorkOrderSidebarView from './WorkOrderSidebarView';

type WorkOrderSidebarProps = {
  id: string;
  onClose: () => void;
};

const WorkOrderSidebar = ({ id, onClose }: WorkOrderSidebarProps) => {
  const { workOrder, loading, error } = useWorkOrderSidebarData(id);

  return (
    <WorkOrderSidebarView
      workOrder={workOrder}
      loading={loading}
      error={error}
      onClose={onClose}
    />
  );
};

export default WorkOrderSidebar;
